import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getLogs = (params, onSuccess, onError) => {
    const response = axios.get('v1/admin/user-logs', { params });
    return handleResponse(response, onSuccess, onError);
};

export const getUserAll = (params, onSuccess, onError) => {
    const response = axios.get('v2/admin/user', { params });
    return handleResponse(response, onSuccess, onError);
};

export const getUserById = (id, onSuccess, onError) => {
    const response = axios.get(`v2/admin/user/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const createUser = (payload, onSuccess, onError) => {
    const response = axios.post(`v2/admin/user`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const softDeleteUser = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v2/admin/user/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const updateUser = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v2/admin/user/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const resetPassword = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v2/admin/user/${id}/reset-password`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const getModenaUserByEmail = (email, onSuccess, onError) => {
    const response = axios.get(`v2/admin/user/${email}/modena`, { params: { perpage: 10 } });
    return handleResponse(response, onSuccess, onError);
};